import React from 'react'
import { View } from 'react-native'

import { Icon, Pressable } from '@zet/design-system'

import { M14, M20 } from '../typography'

interface IProps {
  title: string
  subTitle?: string
  onCrossPress?: () => void
}

export const ScreenTitle: React.FC<IProps> = ({
  title,
  subTitle,
  onCrossPress,
}) => {
  return (
    <View
      className={`${
        subTitle ? 'mb-4' : 'mb-3'
      } flex-row items-center justify-between`}
    >
      <View className={`justify-center`}>
        <M20 className="py-2">{title}</M20>
        {subTitle ? <M14 className="text-grays-80">{subTitle}</M14> : null}
      </View>

      {onCrossPress && (
        <Pressable onPress={onCrossPress}>
          <Icon type="Close" />
        </Pressable>
      )}
    </View>
  )
}
